// adaptTasks.js — wire-dead-engines E3-WS1-T01 (Correction 1).
// @arch:pure-engine
//
// THE load-bearing bridge. specModel.deriveTasksFromSpec emits tasks with `deps`
// (lib/tasks/taskGraph.js shape), but the EXECUTOR's graph (lib/taskGraph.js, consumed by
// taskExecutor.runTaskGraph) reads `depends_on`. Hand `spec.tasks.derived` straight into the
// executor and EVERY task looks dependency-free → all run in wave 1, no chaining, the
// per-task honest-green gate is never honored as a chain. This map fixes that.
//
// Idempotent: a task already carrying a non-empty `depends_on` is preserved. Pure (Tier 1).

export function adaptTasksForExecutor(tasks) {
  if (!Array.isArray(tasks)) return [];
  return tasks.map((t) => {
    const fromDependsOn = Array.isArray(t?.depends_on) && t.depends_on.length ? t.depends_on : null;
    const fromDeps = Array.isArray(t?.deps) ? t.deps : [];
    const depends_on = fromDependsOn || fromDeps;
    return { ...t, depends_on, goal: t?.goal || t?.name || t?.id };
  });
}
